"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSegmentImpression = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_1 = require("react");
var use_is_in_viewport_1 = __importDefault(require("use-is-in-viewport"));
var uuid_1 = require("uuid");
var seo_analytics_1 = require("@nerdwallet/seo-analytics");
var useSegmentImpression = function (_a) {
    var eventName = _a.eventName, segmentAttributes = _a.segmentAttributes;
    var _b = (0, react_1.useState)(false), viewed = _b[0], setViewed = _b[1];
    var analytics = (0, seo_analytics_1.useSegmentAnalytics)().analytics;
    var eventId = (0, react_1.useMemo)(uuid_1.v4, []);
    var _c = (0, use_is_in_viewport_1.default)(), isInViewport = _c[0], ref = _c[1];
    (0, react_1.useEffect)(function () {
        if (isInViewport && !viewed) {
            analytics === null || analytics === void 0 ? void 0 : analytics.track(eventName, __assign({}, segmentAttributes));
            setViewed(true);
        }
    }, [isInViewport]);
    return { ref: ref, eventId: eventId };
};
exports.useSegmentImpression = useSegmentImpression;
